import React from "react";
import mock01 from "../assets/images/mock01.png";
import mock02 from "../assets/images/mock02.png";
import mock03 from "../assets/images/mock03.png";
import mock04 from "../assets/images/mock04.png";
import mock05 from "../assets/images/mock05.png";
import mock06 from "../assets/images/mock06.png";
import mock07 from "../assets/images/mock07.png";
import mock08 from "../assets/images/mock08.png";
import mock09 from "../assets/images/mock09.png";
import mock11 from "../assets/images/detarifish.png";
import mollatarta from "../assets/images/mollatarta.png";
import admin from "../assets/images/laptop.png";
import lezha from "../assets/images/lezhapark.png";
import "../assets/styles/Project.scss";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faJs,
  faReact,
  faNodeJs,
  faJava,
  faWordpress,
  faPhp,
  faCss3Alt,
  faHtml5,
  faNpm,
  faChrome,
  faSass,
  faBootstrap,
} from "@fortawesome/free-brands-svg-icons";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";

function Project() {
  return (
    <div className="projects-container" id="projects">
      <h1>Personal Projects</h1>
      <div className="projects-grid">
        <div className="project">
          <a href="https://detarifish.com" target="_blank" rel="noreferrer">
            <div style={{ background: "white", padding: "30px" }}>
              <img src={mock11} className="zoom" alt="thumbnail" width="100%" />
            </div>
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faReact} size="lg" className="icon" />
            <FontAwesomeIcon icon={faDatabase} size="lg" className="icon" />
            <FontAwesomeIcon icon={faJs} size="lg" className="icon" />
          </div>
          <a
            href="https://github.com/danielfrrokaj/merrBIO-web-app"
            target="_blank"
            rel="noreferrer"
          >
            <h2>DetariFish - Multilingual Self Managed Restaurant Menu</h2>
          </a>
          <p>
            Admin dashboard for managing restaurant menu items, categories, and
            languages. It provides a comprehensive view of the system's
            performance and allows administrators to make informed decisions.
            The dashboard is built using React and TypeScript, frontend is
            deployed on vercel and backend is hosted from supabase. It also
            includes features such as user authentication, role-based access
            control, and data validation.
          </p>
        </div>
        <div className="project">
          <a
            href="https://github.com/danielfrrokaj/merrBIO-web-app"
            target="_blank"
            rel="noreferrer"
          >
            <div style={{ background: "orange", padding: "30px" }}>
              <img src={admin} className="zoom" alt="thumbnail" width="100%" />
            </div>
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faReact} size="lg" className="icon" />
            <FontAwesomeIcon icon={faDatabase} size="lg" className="icon" />
            <FontAwesomeIcon icon={faJs} size="lg" className="icon" />
          </div>
          <a
            href="https://github.com/danielfrrokaj/merrBIO-web-app"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Superadmin Dashboard - MerrBio Hackathon</h2>
          </a>
          <p>
            Superadmin dashboard with features like user management, data
            analytics, and real-time monitoring. It provides a comprehensive
            view of the system's performance and allows administrators to make
            informed decisions. The dashboard is built using React and
            TypeScript, frontend is deployed on vercel and backend is hosted
            from supabase.
          </p>
        </div>
        <div className="project">
          <a
            href="https://merr-bio-web-app.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            <div style={{ background: "orange", padding: "30px" }}>
              <img
                src={mollatarta}
                className="zoom"
                alt="thumbnail"
                width="100%"
              />
            </div>
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faReact} size="lg" className="icon" />
            <FontAwesomeIcon icon={faDatabase} size="lg" className="icon" />
            <FontAwesomeIcon icon={faJs} size="lg" className="icon" />
          </div>
          <a
            href="https://merr-bio-web-app.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Mollat'Arta - MerrBio Hackathon</h2>
          </a>
          <p>
            Developed Mollat'Arta during the MerrBio Hackathon. The project was
            created to connect local farmers to the local community and provide
            them with a platform to sell their products directly to consumers.
            We've used React and Supabase for this project.
          </p>
        </div>
        <div className="project">
          <a
            href="https://chromewebstore.google.com/detail/focus-timer-and-task-mana/ocaajdaaekpmopddjnobakkpkemeggmk"
            target="_blank"
            rel="noreferrer"
          >
            <img src={mock08} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faJs} size="lg" className="icon" />
            <FontAwesomeIcon icon={faHtml5} size="lg" className="icon" />
            <FontAwesomeIcon icon={faCss3Alt} size="lg" className="icon" />
            <FontAwesomeIcon icon={faChrome} size="lg" className="icon" />
          </div>
          <a
            href="https://chromewebstore.google.com/detail/focus-timer-and-task-mana/ocaajdaaekpmopddjnobakkpkemeggmk"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Task Manager & Pomodoro Timer - Chrome Extension</h2>
          </a>
          <p>
            Developed a chrome extension using pure JavaScript to enhance
            productivity in my daily life.
          </p>
        </div>
        <div className="project">
          <a
            href="https://github.com/teo-developer/QuickSaver-ChromeExtension"
            target="_blank"
            rel="noreferrer"
          >
            <img src={mock07} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faJs} size="lg" className="icon" />
            <FontAwesomeIcon icon={faHtml5} size="lg" className="icon" />
            <FontAwesomeIcon icon={faCss3Alt} size="lg" className="icon" />
            <FontAwesomeIcon icon={faChrome} size="lg" className="icon" />
          </div>
          <a
            href="https://github.com/teo-developer/QuickSaver-ChromeExtension"
            target="_blank"
            rel="noreferrer"
          >
            <h2>QuickSaver - Chrome Extension</h2>
          </a>
          <p>
            This is a chrome extension that provides a simple bookmark
            management feature allowing users to bookmark websites they want to
            visit later.
          </p>
        </div>
        <div className="project">
          <a
            href="https://github.com/DVA232/ht24-projects-3"
            target="_blank"
            rel="noreferrer"
          >
            <img src={mock09} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faJava} size="lg" className="icon" />
            <FontAwesomeIcon icon={faNodeJs} size="lg" className="icon" />
            <FontAwesomeIcon icon={faDatabase} size="lg" className="icon" />
          </div>
          <a
            href="https://github.com/DVA232/ht24-projects-3"
            target="_blank"
            rel="noreferrer"
          >
            <h2>BookIt: Smart Room Booking System</h2>
          </a>
          <p>
            This mobile application allows users to book rooms in a university,
            it's built using Kotlin, node.js and mySQL.'.
          </p>
        </div>
        <div className="project">
          <a href="https://nordfix.se/" target="_blank" rel="noreferrer">
            <img src={mock06} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faWordpress} size="lg" className="icon" />
            <FontAwesomeIcon icon={faPhp} size="lg" className="icon" />
            <FontAwesomeIcon icon={faDatabase} size="lg" className="icon" />
          </div>
          <a href="https://nordfix.se/" target="_blank" rel="noreferrer">
            <h2>Nordfix: Property Services</h2>
          </a>
          <p>
            This website is built using Wordpress and Divi Theme Builder
            following best UI/UX practices.
          </p>
        </div>
        <div className="project">
          <a
            href="https://react-task-weather-app.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={mock05} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faReact} size="lg" className="icon" />
            <FontAwesomeIcon icon={faSass} size="lg" className="icon" />
            <FontAwesomeIcon icon={faJs} size="lg" className="icon" />
          </div>
          <a
            href="https://react-task-weather-app.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            <h2>React Weather Project</h2>
          </a>
          <p>
            A react.js app using tailwind for styles, fetches data from a free
            API and displays them in the best way possible, it also offers a
            free weather widget for developers to use.
          </p>
        </div>
        <div className="project">
          <a
            href="https://orarinekalendar.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={mock04} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faReact} size="lg" className="icon" />
            <FontAwesomeIcon icon={faJs} size="lg" className="icon" />
            <FontAwesomeIcon icon={faNpm} size="lg" className="icon" />
          </div>
          <a
            href="https://orarinekalendar.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Calendar Importer for Courses</h2>
          </a>
          <p>
            A next.js simple app that imports courses from form and generates an
            ICS file for easy import into different calendars.
          </p>
        </div>
        <div className="project">
          <a href="https://zemraepatokut.com/" target="_blank" rel="noreferrer">
            <img src={mock03} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faWordpress} size="lg" className="icon" />
            <FontAwesomeIcon icon={faPhp} size="lg" className="icon" />
            <FontAwesomeIcon icon={faDatabase} size="lg" className="icon" />
          </div>
          <a href="https://zemraepatokut.com/" target="_blank" rel="noreferrer">
            <h2>Restaurant Website</h2>
          </a>
          <p>
            Designed and developed a website for a restaurant using Divi
            Wordpress. The website includes a menu, reservation system.
          </p>
        </div>
        <div className="project">
          <a href="https://giardino.al/" target="_blank" rel="noreferrer">
            <img src={mock02} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faWordpress} size="lg" className="icon" />
            <FontAwesomeIcon icon={faPhp} size="lg" className="icon" />
            <FontAwesomeIcon icon={faDatabase} size="lg" className="icon" />
          </div>
          <a href="https://giardino.al/" target="_blank" rel="noreferrer">
            <h2>Pizzeria Website</h2>
          </a>
          <p>
            Giardino is one of the most famous pizzerias in northern Albania. I
            created a website for them using Divi Wordpress. The website
            includes a landing page, menu and a reservation system.
          </p>
        </div>
        <div className="project">
          <a
            href="https://armandoproduction.info/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={mock01} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faWordpress} size="lg" className="icon" />
            <FontAwesomeIcon icon={faPhp} size="lg" className="icon" />
            <FontAwesomeIcon icon={faBootstrap} size="lg" className="icon" />
          </div>
          <a
            href="https://armandoproduction.info/"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Wedding Film Production </h2>
          </a>
          <p>
            A landing page with a reservation system and pricing information
            following best UI/UX Practices.
          </p>
        </div>
        <div className="project">
          <a
            href="https://armandoproduction.info/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={lezha} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <div className="icon-container">
            <FontAwesomeIcon icon={faWordpress} size="lg" className="icon" />
            <FontAwesomeIcon icon={faPhp} size="lg" className="icon" />
            <FontAwesomeIcon icon={faBootstrap} size="lg" className="icon" />
          </div>
          <a
            href="https://armandoproduction.info/"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Lezha Park Wordpress Commercial Website </h2>
          </a>
          <p>
            Commercial website for a bar-restaurant in the heart of the city,
            built on wordpress and divi website builder.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Project;
